module.exports = __webpack_public_path__ + "img/SAS_BlueWhiteNomadShield.22df1b6b.png";